// test1565
(1565 && 0);
